export default __webpack_public_path__ + "static/media/amm-logo-white.a5285e90.png";